export const StatusCodes = {
    USER_NOT_EXIST: 0,
    USER_ACTIVE: 1,
    USER_ALREADY_EXIST: 2,
    USER_INACTIVE: 3,
    CREATE_USER: 4,
    OTP_EXPIRED: 5,
    OTP_EXCEED_RLIMIT: 6,
    SUCCESS: 7,
    FAIL: 8,
    CREATE_OTP: 9,
    USE_EXISTING_OTP: 10,
    USER_TM_EXPIRED: 11,
    OTP_NOT_EXIST: 12,
    OTP_WRONG: 13,
    OTP_SUCCESS: 14,
    IMG_EXCIDE_MAX: 15,
    IMG_WRONG_FORMAT: 16,
    IMG_OK: 17,
    NO_FILES: 18,
    MOBILE_LOGIN: 19,
    WEB_LOGIN: 20,
    PSWD_WRONG: 21,
    PSWD_CORRECT: 22,
    IMG_UPLOADED: 23,
    IMG_NOTUPLOADED: 24,
    IMG_EXCEDECOUNT: 25,
    IMG_ONEPHOTO: 26,
    IMG_EXCEDECOUNT_TRANS: 27,
  };
  
  export const getStatusMessage = (code) => {
    const messages = {
      [StatusCodes.USER_NOT_EXIST]: 'User does not exist.',
      [StatusCodes.USER_ACTIVE]: 'User is active.',
      [StatusCodes.USER_ALREADY_EXIST]: 'Your already exists. Please login',
      [StatusCodes.USER_INACTIVE]: 'Your not verified your email, click singUp and verify',
      [StatusCodes.CREATE_USER]: 'User created successfully.',
      [StatusCodes.OTP_EXPIRED]: 'OTP has expired.',
      [StatusCodes.OTP_EXCEED_RLIMIT]: 'OTP verification exceeded limit, Please try after 1 hour.',
      [StatusCodes.SUCCESS]: 'Operation successful.',
      [StatusCodes.FAIL]: 'Operation failed.',
      [StatusCodes.CREATE_OTP]: 'OTP has been sent to mail.',
      [StatusCodes.USE_EXISTING_OTP]: 'Use previously generated OTP.',
      [StatusCodes.USER_TM_EXPIRED]: 'User session expired.',
      [StatusCodes.OTP_NOT_EXIST]: 'OTP not found.',
      [StatusCodes.OTP_WRONG]: 'Incorrect OTP.',
      [StatusCodes.OTP_SUCCESS]: 'OTP verified successfully.',
      [StatusCodes.IMG_EXCIDE_MAX]: 'Image exceeds maximum allowed size.',
      [StatusCodes.IMG_WRONG_FORMAT]: 'Invalid image format.',
      [StatusCodes.IMG_OK]: 'Image is OK.',
      [StatusCodes.NO_FILES]: 'No files uploaded.',
      [StatusCodes.MOBILE_LOGIN]: 'Login via mobile.',
      [StatusCodes.WEB_LOGIN]: 'Login via web.',
      [StatusCodes.PSWD_WRONG]: 'Incorrect password.',
      [StatusCodes.PSWD_CORRECT]: 'Password is correct.',
      [StatusCodes.IMG_UPLOADED]: 'Image uploaded.',
      [StatusCodes.IMG_NOTUPLOADED]: 'Image not uploaded.',
      [StatusCodes.IMG_EXCEDECOUNT]: 'Exceeded image count limit.',
      [StatusCodes.IMG_ONEPHOTO]: 'Only one photo allowed.',
      [StatusCodes.IMG_EXCEDECOUNT_TRANS]: 'Transaction image count exceeded.',
    };
  
    return messages[code] || 'Unknown status code.';
  };
  